import { SummaryConfig } from "../../../hooks";

export const lenticuleGradingSummaryConfig: SummaryConfig = {
    epithelium: [
        {
            accessor: "epitheliumRemoved",
            renderer: "Epithelium Removed.",
        },
        {
            accessor: "traceEpithelialPresent",
            renderer: "Trace Epithelial Remnants Present.",
        },
        {
            accessor: "epitheliumComments",
        },
    ],
    stroma: [
        {
            accessor: "stroma.posteriorThickness",
            formatter: (val) => `Approximate Graft Thickness: ${val} µm.`,
        },
        {
            accessor: "stroma.size",
            formatter: (val) => `Approximate Graft Size: ${val} mm.`,
        },
        {
            accessor: "",
            renderer: (data) => {
                const { capOrientation, capOrientationLocation } = data.stroma ?? {};
                if (!capOrientation) return "";
                if (capOrientation === "yes") {
                    return "Cap is oriented on the stromal bed within 1 mm.";
                } else {
                    return `Cap location is within ${capOrientationLocation ?? ""} mm.`;
                }
            },
        },
        {
            accessor: "stroma.sMark.checked",
            renderer: {
                "title": "'S' mark placed",
                "stroma.sMarkVisibility": "",
            },
        },
        {
            accessor: "stroma.fMark.checked",
            renderer: {
                "title": "'F' mark placed",
                "stroma.fMarkVisibility": "",
            },
        },
        {
            accessor: "stroma.linePattern.checked",
            renderer: {
                "title": "1:2 line pattern",
                "stroma.linePatternVisibility": "",
            },
        },
        {
            accessor: "stroma.centration",
            renderer: "Centration Dot Placed.",
        },
        {
            accessor: "stroma.comments",
        },
    ],
};
